import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-currency',
  templateUrl: './currency.component.html',
  styleUrls: ['./currency.component.less']
})
export class CurrencyComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() mode: string;
  @Output() submitChanges: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  submit() {
    this.submitChanges.emit();
  }

  recordLoaded(record: any) {}

  beforeSubmit() {}

  cleanRecord(record: any) : any{
    return record;
  }

  static controls(mode: string) {
    const controlsToReturn: any = {};
    if(mode === 'edit') {
      controlsToReturn['Id'] = [null, []];
    }

    controlsToReturn['Name'] = [null, [Validators.required]];
    controlsToReturn['CurrencyCode'] = [null, [Validators.required]];
    controlsToReturn['Iso'] = [null, [Validators.required]];

    return controlsToReturn;
  }
}
